// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file entities/app/my_account/info_sheet.proto (package protos.entities.app.my_account, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { EyeColor } from "../../../general/eye_color_pb";
import { file_general_eye_color } from "../../../general/eye_color_pb";
import type { HairColor } from "../../../general/hair_color_pb";
import { file_general_hair_color } from "../../../general/hair_color_pb";
import type { Gender } from "../../../general/gender_pb";
import { file_general_gender } from "../../../general/gender_pb";
import type { Ethnicity } from "../../../general/ethnicity_pb";
import { file_general_ethnicity } from "../../../general/ethnicity_pb";
import type { SpokenLanguage } from "../../../general/spoken_language_pb";
import { file_general_spoken_language } from "../../../general/spoken_language_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file entities/app/my_account/info_sheet.proto.
 */
export const file_entities_app_my_account_info_sheet: GenFile = /*@__PURE__*/
  fileDesc("CihlbnRpdGllcy9hcHAvbXlfYWNjb3VudC9pbmZvX3NoZWV0LnByb3RvEh5wcm90b3MuZW50aXRpZXMuYXBwLm15X2FjY291bnQiwwMKCUluZm9TaGVldBIOCgZoZWlnaHQYASABKA0SGwoTb25fc2NyZWVuX2FnZV9zdGFydBgCIAEoDRIbChFvbl9zY3JlZW5fYWdlX2VuZBgDIAEoDUgAEisKCWV5ZV9jb2xvchgEIAEoDjIYLnByb3Rvcy5nZW5lcmFsLkV5ZUNvbG9yEi0KCmhhaXJfY29sb3IYBSABKA4yGS5wcm90b3MuZ2VuZXJhbC5IYWlyQ29sb3ISJgoGZ2VuZGVyGAYgASgOMhYucHJvdG9zLmdlbmVyYWwuR2VuZGVyEiwKCWV0aG5pY2l0eRgHIAEoDjIZLnByb3Rvcy5nZW5lcmFsLkV0aG5pY2l0eRJVChBzcG9rZW5fbGFuZ3VhZ2VzGAggAygLMjsucHJvdG9zLmVudGl0aWVzLmFwcC5teV9hY2NvdW50LkluZm9TaGVldC5JbmZvU2hlZXRMYW5ndWFnZRpFChFJbmZvU2hlZXRMYW5ndWFnZRIwCghsYW5ndWFnZRgBIAEoDjIeLnByb3Rvcy5nZW5lcmFsLlNwb2tlbkxhbmd1YWdlQhwKGm9wdGlvbmFsX29uX3NjcmVlbl9hZ2VfZW5kYgZwcm90bzM", [file_general_eye_color, file_general_hair_color, file_general_gender, file_general_ethnicity, file_general_spoken_language]);

/**
 * @generated from message protos.entities.app.my_account.InfoSheet
 */
export type InfoSheet = Message<"protos.entities.app.my_account.InfoSheet"> & {
  /**
   * @generated from field: uint32 height = 1;
   */
  height: number;

  /**
   * @generated from field: uint32 on_screen_age_start = 2;
   */
  onScreenAgeStart: number;

  /**
   * @generated from oneof protos.entities.app.my_account.InfoSheet.optional_on_screen_age_end
   */
  optionalOnScreenAgeEnd: {
    /**
     * @generated from field: uint32 on_screen_age_end = 3;
     */
    value: number;
    case: "onScreenAgeEnd";
  } | { case: undefined; value?: undefined };

  /**
   * @generated from field: protos.general.EyeColor eye_color = 4;
   */
  eyeColor: EyeColor;

  /**
   * @generated from field: protos.general.HairColor hair_color = 5;
   */
  hairColor: HairColor;

  /**
   * @generated from field: protos.general.Gender gender = 6;
   */
  gender: Gender;

  /**
   * @generated from field: protos.general.Ethnicity ethnicity = 7;
   */
  ethnicity: Ethnicity;

  /**
   * @generated from field: repeated protos.entities.app.my_account.InfoSheet.InfoSheetLanguage spoken_languages = 8;
   */
  spokenLanguages: InfoSheet_InfoSheetLanguage[];
};

/**
 * Describes the message protos.entities.app.my_account.InfoSheet.
 * Use `create(InfoSheetSchema)` to create a new message.
 */
export const InfoSheetSchema: GenMessage<InfoSheet> = /*@__PURE__*/
  messageDesc(file_entities_app_my_account_info_sheet, 0);

/**
 * @generated from message protos.entities.app.my_account.InfoSheet.InfoSheetLanguage
 */
export type InfoSheet_InfoSheetLanguage = Message<"protos.entities.app.my_account.InfoSheet.InfoSheetLanguage"> & {
  /**
   * @generated from field: protos.general.SpokenLanguage language = 1;
   */
  language: SpokenLanguage;
};

/**
 * Describes the message protos.entities.app.my_account.InfoSheet.InfoSheetLanguage.
 * Use `create(InfoSheet_InfoSheetLanguageSchema)` to create a new message.
 */
export const InfoSheet_InfoSheetLanguageSchema: GenMessage<InfoSheet_InfoSheetLanguage> = /*@__PURE__*/
  messageDesc(file_entities_app_my_account_info_sheet, 0, 0);

